export default {
  subsidy: {
    id: 'product_page_google_shopping_mobile_plan_subsidy',
    defaultMessage: 'dont -{amount} avec ce forfait',
  },
}
